import { gql } from "@apollo/client";

export const GET_BOOKING_CHANGES = gql`
  query GetBookingChanges($filter: BookingChangesFilter, $limit: Int, $offset: Int) {
    getBookingChanges(filter: $filter, limit: $limit, offset: $offset) {
      status
      message
      data {
        summary {
          changes
          edits
          verifications
          bookings
          priceChanged
          priceUp
          priceDown
        }
        actors {
          id
          name
          type
          changes
          edits
          verifications
          priceUp
          priceDown
        }
        fields {
          label
          count
        }
        total
        entries {
          id
          createdAt
          kind
          orderId
          bookingId
          bookingDate
          customerName
          professionalName
          actorId
          actorName
          actorType
          reason
          priceDelta
          changes
          partial
        }
      }
    }
  }
`;
